import { type LeadCsvExportResponse } from '@/stores/types/leads';
import { ContentType, FileFormat } from '@/types';
import { captureError } from '@smg-real-estate/browser-rum';
import { get } from './fetch';

export interface DateRange {
  startDate?: string;
  endDate?: string;
}

export interface ContactRequestParams extends DateRange {
  listerId?: string;
  propertyReferenceId?: string;
  fileFormat: FileFormat;
  lang?: string;
  address?: string;
}

export class LeadCsvExportError extends Error {
  endpoint: string;

  constructor(endpoint: string, message: string) {
    super(`Error getting file export url: ${message}`);
    this.name = 'LeadFileExportError';
    this.endpoint = endpoint;
  }
}

export async function getCsvExportUrl(
  params: ContactRequestParams,
): Promise<LeadCsvExportResponse> {
  const queryParams = new URLSearchParams();

  if (params.startDate) {
    queryParams.append('startDate', params.startDate);
  }
  if (params.endDate) {
    queryParams.append('endDate', params.endDate);
  }
  if (params.lang) {
    queryParams.append('lang', params.lang);
  }

  const path = params.propertyReferenceId
    ? `property/${encodeURIComponent(params.propertyReferenceId)}`
    : `lister/${params.listerId}`;
  const requestUrl = `${import.meta.env.VUE_UBM_CONTACT_REQUEST_API_URL}/${path}?${queryParams.toString()}`;

  try {
    const response = await get(requestUrl, undefined, {
      Accept: ContentType[params.fileFormat],
      Date: new Date().toISOString(),
    });
    return response.json();
  } catch (error) {
    const err = new LeadCsvExportError(requestUrl, error.message);
    captureError(err);
    throw err;
  }
}
